import { connect } from 'react-redux';

import { withOverlayControls } from '@eb/eds-structure';

import {
    LocationAutocomplete,
    getLocationSuggestions,
} from '@eb/location-autocomplete';

import { searchLocationSuggestions as searchLocationSuggestionsAction } from '../../SearchApp/actions/location';

const _mapStateToProps = (state, ownProps) => ({
    currentPlace:
        ownProps.hideOnline && state.location.isOnline
            ? ''
            : state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    placeholder: 'Choose a location',
    isBBoxSearch: !!state.search.eventSearch.bbox,
    isUseCurrentLocationEnabled: state.app.featureFlags.useCurrentLocation,
    isUsingCurrentLocation: state.location.isUsingCurrentLocation,
    isWaitingForLocation: state.location.isWaitingForLocation,
    locationSuggestions: getLocationSuggestions(
        state.location,
        state.app.featureFlags.useCurrentLocation,
    ),
    placeId: state.location.placeId,
    googleMapsApiKey: state.googleMapsApiKey,
    latitude: state.location.latitude,
    longitude: state.location.longitude,
    isOnline: state.location.isOnline,
});

const _mapDispatchToProps = {
    handleLocationSuggestionChange: searchLocationSuggestionsAction,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(LocationAutocomplete),
);
